export default "__VITE_ASSET__DWsuMGbi__"